




























































import { Component, Prop, Provide, Vue } from "vue-property-decorator";
import { getBirthday, getTimeAgo } from "@/services/dateTime/date-time-fofmat";
import { IActivityStatus as IUser } from "@/@types/admin/activity-status";

import TvTable from "./tv_user/tv-table.vue";
import TvCommandButtons from "@/components/buttons/tv/tv-command-buttons.vue";
import TvSettings from "./tv_user/tv-settings.vue";
import TvCommands from "@/components/tables/administration/tv-commands.vue";
import AddTvAdminForm from "@/components/forms/tv_admin/add-tv-admin-form.vue";
import ButtonCart from "@/components/buttons/button-cart.vue";
import InputSearch from "@/components/app/search/input-search.vue";
import TvMailsForm from "@/components/forms/tv_admin/tv-mails/tv-mails-form.vue";

@Component({
  name: "tv-administration",
  components: {
    TvCommandButtons,
    TvSettings,
    TvCommands,
    AddTvAdminForm,
    TvTable,
    TvMailsForm,
    ButtonCart,
    InputSearch,
  },
})
export default class TvAdministrationList extends Vue {
  @Prop({ type: Array, default: () => [] }) users!: IUser[];
  @Prop({ type: Boolean, default: false }) deleted!: boolean;
  @Prop({ type: String, default: "tv" }) deviceType!: string;
  @Prop({ type: Boolean, default: true }) showLinkedBlock!: boolean;
  @Provide() commands: Array<string> = ["getHcapMode"];

  get labelPrefix(): string {
    return this.deviceType == "tablet"
      ? "Administration.tablet"
      : "Administration.tv";
  }

  user_id = "";
  mail_type = "";

  openMailForm(type: string, id: string): void {
    this.user_id = id;
    this.mail_type = type;
    this.$nextTick(() => this.$bvModal.show("tv-mails-form"));
  }

  getBirthday(date: string | Date): string {
    return getBirthday(date);
  }

  getDateTime(date: string | Date): string {
    return getTimeAgo(date);
  }

  async dropTVs(): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("main.confirms.delete-all")),
        }
      );

      if (result === true) {
        const tvs: Array<string> = [];
        this.users.forEach((user) => tvs.push(user._id));
        this.$emit("deleted", tvs);
      }
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  befoDestroyed(): void {
    this.user_id = "";
  }
}
